import { render, staticRenderFns } from "./StudentReportView.vue?vue&type=template&id=242fccb0&"
import script from "./StudentReportView.vue?vue&type=script&lang=js&"
export * from "./StudentReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports